import type { CardOpen } from '@camino-solutions/share/proto/common/services';

export class SessionMessageProcessingCardOpenAction {
  static readonly type = '[Session] Message processing: Card open';

  constructor(readonly cardOpen: CardOpen) {}
}
